import React from 'react';
import GarmentMeasurement from './GarmentMeasurement';

// TODO: remove event listeners once we have swatches in MFE
export default function GarmentMeasurementSection({ textContent, garmentMeasurements }) {
  return (
    <div className="garment-measurements-section" data-testid="garment-measurements-section">
      <h4>{textContent?.garmentHeaderText?.value}</h4>
      <GarmentMeasurement
        measurementSize={garmentMeasurements.baseMeasurementSize}
        measurementText={textContent?.baseText?.value}
      />
      <div className="garment-measurements-section__measurements">
        {garmentMeasurements.baseSleeveLengthMeasurement && (
        <GarmentMeasurement
          measurementSize={`${garmentMeasurements.baseSleeveLengthMeasurement}"`}
          measurementText={textContent?.sleeveLengthText?.value}
          tooltipHeader={textContent?.baseSleeveLengthTooltipHeader?.value}
          tooltipText={textContent?.baseSleeveLengthTooltipText?.value}
        />
        )}
        {garmentMeasurements?.baseShoulderToHemMeasurement && (
        <GarmentMeasurement
          measurementSize={`${garmentMeasurements?.baseShoulderToHemMeasurement}"`}
          measurementText={textContent?.shoulderText?.value}
          tooltipHeader={textContent?.baseShoulderTooltipHeader?.value}
          tooltipText={textContent?.baseShoulderTooltipText?.value}
        />
        )}
        {garmentMeasurements?.baseInseamXShortMeasurement && (
        <GarmentMeasurement
          measurementSize={`${garmentMeasurements?.baseInseamXShortMeasurement}"`}
          measurementText={textContent?.xtraShortText?.value}
          tooltipHeader={textContent?.baseMeasurementTooltipHeader?.value}
          tooltipText={textContent?.baseMeasurementTooltipText?.value}
        />
        )}
        {garmentMeasurements?.baseInseamShortMeasurement && (
        <GarmentMeasurement
          measurementSize={`${garmentMeasurements?.baseInseamShortMeasurement}"`}
          measurementText={textContent?.shortText?.value}
          tooltipHeader={textContent?.baseMeasurementTooltipHeader?.value}
          tooltipText={textContent?.baseMeasurementTooltipText?.value}
        />
        )}
        {garmentMeasurements.baseInseamRegularMeasurement && (
        <GarmentMeasurement
          measurementSize={`${garmentMeasurements.baseInseamRegularMeasurement}"`}
          measurementText={textContent?.regularText?.value}
          tooltipHeader={textContent?.baseMeasurementTooltipHeader?.value}
          tooltipText={textContent?.baseMeasurementTooltipText?.value}
        />
        )}
        {garmentMeasurements.baseInseamLongMeasurement && (
        <GarmentMeasurement
          measurementSize={`${garmentMeasurements.baseInseamLongMeasurement}"`}
          measurementText={textContent?.longText?.value}
          tooltipHeader={textContent?.baseMeasurementTooltipHeader?.value}
          tooltipText={textContent?.baseMeasurementTooltipText?.value}
        />
        )}
        {garmentMeasurements.baseFrontRiseMeasurement && (
        <GarmentMeasurement
          measurementSize={`${garmentMeasurements.baseFrontRiseMeasurement}"`}
          measurementText={textContent?.frontRiseText?.value}
          tooltipHeader={textContent?.baseFrontRiseTooltipHeader?.value}
          tooltipText={textContent?.baseFrontRiseTooltipText?.value}
        />
        )}
        {garmentMeasurements.baseLegOpeningMeasurement && (
        <GarmentMeasurement
          measurementSize={`${garmentMeasurements.baseLegOpeningMeasurement}"`}
          measurementText={textContent?.legOpeningText?.value}
          tooltipHeader={textContent?.baseLegOpeningTooltipHeader?.value}
          tooltipText={textContent?.baseLegOpeningTooltipText?.value}
        />
        )}
        {garmentMeasurements.baseSkirtLengthMeasurement && (
        <GarmentMeasurement
          measurementSize={`${garmentMeasurements.baseSkirtLengthMeasurement}"`}
          measurementText={textContent?.skirtLengthText?.value}
          tooltipHeader={textContent?.baseSkirtLengthTooltipHeader?.value}
          tooltipText={textContent?.baseSkirtLengthTooltipText?.value}
        />
        )}
      </div>
    </div>
  );
}
